import vRender from "./v-render.vue";

export default Vue => {
  Vue.component("v-render", vRender);
};
